import React from 'react';
import './App.css';
import Measurement from './routes/measurement/Measurement';
import Pvstatus from './routes/pvstatus/Pvstatus';
import Statistics from './routes/statistics/statistics';
import Alarm from './routes/alarm/alarm';
import Setting from './routes/admin/setting';
import VibrationDetection from './routes/VibrationDetection';
import Navbar from './public/Navbar';
import { Outlet, useLocation } from "react-router-dom";
import { Routes, Route } from 'react-router-dom';
import SchedulePage from './routes/schedule/SchedulePage';
import DiagramPage from './routes/diagram/DiagramPage';


function App() {


  return (

      <Routes>
        {/* Navbar를 포함하는 구조로 수정 */}
        <Route path="/" element={<Navbar />}>
          <Route index element={<Pvstatus />} />
          <Route path="pvstatus" element={<Pvstatus />} />
          <Route path="measurement" element={<Measurement />} />
          <Route path="statistics" element={<Statistics />} />
          <Route path="alarm" element={<Alarm />} />
          <Route path="vibrationDetection" element={<VibrationDetection />} />
          <Route path="schedule" element={<SchedulePage />} />
          <Route path="diagram" element={<DiagramPage />} />
        </Route>
        <Route path="admin" element={<Setting />} />
      </Routes>

  );
}

export default App;
